import type { ReadinessState, ReadinessVerdict } from "@shared/labs/level-assessment-readiness";
import { C, DM, UI } from "../results/ui-tokens";

/**
 * Client-facing readiness chip for the calibration workflow. Plain-HR labels —
 * never exposes "bootstrap", prompts, or matrix internals. Three states:
 * Rascunho (draft) / Em calibração (calibrating) / Calibrado (ready).
 */
const STATE_STYLE: Record<ReadinessState, { label: string; fg: string; bg: string }> = {
  draft: { label: "Rascunho", fg: C.ink50, bg: C.ink5 },
  calibrating: { label: "Em calibração", fg: C.amberFg, bg: C.amberBg },
  ready: { label: "Calibrado", fg: C.greenFg, bg: C.greenBg },
};

export function ReadinessBadge({
  readiness,
  showDetail = false,
}: {
  readiness: ReadinessVerdict;
  /** When true, render the plain-language reasons under the chip. */
  showDetail?: boolean;
}) {
  const s = STATE_STYLE[readiness.state];
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
      <span
        data-testid="readiness-badge"
        data-state={readiness.state}
        style={{
          ...DM,
          alignSelf: "flex-start",
          fontWeight: 700,
          fontSize: 12,
          padding: "4px 12px",
          borderRadius: 999,
          color: s.fg,
          background: s.bg,
        }}
      >
        {s.label}
      </span>
      {showDetail && readiness.reasons.length > 0 && (
        <ul style={{ ...UI, margin: 0, paddingLeft: 16, fontSize: 12.5, color: C.ink50 }}>
          {readiness.reasons.map((r) => (
            <li key={r}>{r}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
